export default "__VITE_ASSET__DHkg3_mM__"